import { userMetadataService } from '../../helpers/services/userMetadata.service'
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'

export const state = {
  list: {
    data: [],
    pagination: { pageNumber: 0, pageSize: 0, lastPage: 0, tableRowsCount: 0 },
  },
  details: {},
  status: { list: true, detail: true, save: true },
}

export const USER_METADATA_MODULE = 'userMetadata'

export const GET_ALL_USER_METADATA = 'getAllUserMetadata'
export const APPROVE_USER_METADATA = 'approveUserMetadata'

const REQUESTING = 'requesting'
const ALL_SUCCESS = 'allSuccess'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'

function mapRow(item) {
  return {
    id: item.uuid,
    uuid: item.uuid,
    userId: item.user_id,
    userName: item.user?.name,
    userEmail: item.user?.email,
    name: item.name,
    debtorCode: item.debtor_code,
    longitude: item.longitude,
    latitude: item.latitude,
    image: item.image,
    isApproved: item.is_approved ?? !!item.approved_at,
    approvedBy: item.approved_by?.name || item.approved_by_uuid,
    isActive: item.is_active,
    isOwnRecord: !!item.is_own_record,
    createdAt: filtersHelper.getDateFormat(item.created_at),
    createdAtRaw: item.created_at,
    updatedAt: filtersHelper.getDateFormat(item.updated_at),
  }
}

export const actions = {
  [GET_ALL_USER_METADATA]({ commit }, { filter }) {
    commit(REQUESTING, 'list')
    userMetadataService
      .getAllUserMetadata(filter)
      .then((result) => {
        commit(ALL_SUCCESS, { data: result })
        commit(SUCCESS)
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
  [APPROVE_USER_METADATA]({ commit, dispatch }, { id, filter }) {
    commit(REQUESTING, 'save')
    return userMetadataService
      .approveUserMetadata(id)
      .then((result) => {
        sharedHelper.alertSuccessMessage(i18n.t('label.updateX', [i18n.t('module.userMetadata')]))
        commit(SUCCESS)
        dispatch(GET_ALL_USER_METADATA, { filter })
        return result
      })
      .catch((error) => {
        sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(error), error?.response?.data?.code)
        commit(FAILURE)
      })
  },
}

export const mutations = {
  [ALL_SUCCESS](state, { data }) {
    const items = data.data || []
    state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)
    state.list.data = data.success ? items.map(mapRow) : items
  },
  [FAILURE](state) {
    state.status = { list: true, detail: true, save: true }
  },
  [REQUESTING](state, type) {
    state.status[type] = false
  },
  [SUCCESS](state) {
    state.status = { list: true, detail: true, save: true }
  },
}
